import { Client } from "./baseurl";

export const getProvincias = async() => {
  const response = await Client.get('/home/provinces');
  return response.data;
}
